'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Text } from '../text';
import { progressStepperStepMetaTextStyles } from './styles/progress-stepper-step-meta-text.styles';
import type { ProgressStepperStepMetaTextPropsInterface } from './types/progress-stepper-step-meta-text.types';

/**
 * ProgressStepper.StepLabel's meta section container
 *
 * @since 10.0.0
 */
export const ProgressStepperStepMetaText = forwardRef<
  HTMLDivElement,
  ProgressStepperStepMetaTextPropsInterface
>((props: ProgressStepperStepMetaTextPropsInterface, forwardedRef) => {
  const { children, css: cssProp, ...rest } = props;

  return (
    <Text
      data-c11n-component="ProgressStepper.StepMetaText"
      data-c11n-version={__C11N_VERSION__}
      css={css.raw(progressStepperStepMetaTextStyles, cssProp)}
      ref={forwardedRef}
      {...rest}
      className={cx('c11n_progress-stepper__step-meta-text', rest.className)}
    >
      {children}
    </Text>
  );
});

ProgressStepperStepMetaText.displayName = 'ProgressStepper.StepMetaText';
